import config from '../config/config';
import yaml from 'js-yaml';
import AuthRequestHelper from "./AuthRequestHelper"

class BotHelper {
    constructor() { 
        this.allowedKeys = new Set([
            'userNickname',
            'botNickname',
            'userBirthdate',
            'userGender',
            'relation',
            'userOccupation',
            'deathReason',
            'otherReason',
            'big5Practicality',
            'big5Flexibility',
            'big5Introversion',
            'big5Independence',
            'big5Composure',
        ])
    }

    async queryBot(message = "", bot_id = "", conversation_id = "", user_id = "",lang="en") {
        // console.log("the bot id used ", bot_id)
        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");

        // var raw = JSON.stringify({
        //     "text": message,
        //     "bot_id": bot_id, // Use selected bot_id here
        //     "conversation_id": conversation_id, // Include conversation_id
        //     "lang":lang,
        //     "user_id": user_id
        // });
        var raw = {
            "text": message,
            "bot_id": bot_id, // Use selected bot_id here
            "conversation_id": conversation_id, // Include conversation_id
            "lang":lang,
            "user_id": user_id
        };
        var requestOptions = {
            method: 'POST',
            headers: myHeaders,
            body: raw,
            redirect: 'follow'
        };
        const requestUrl='/gptchat'
        // const r = await fetch(`${config.localAuth.apiServiceUrl}` + '/gptchat', requestOptions)
        let r=await AuthRequestHelper.request("post",requestUrl,raw) 
            .then(response => response.json())
            .then(result => result)
            .catch(error => false);
        return r;
    }
    
    async queryPdfBot(message = "", bot_id = "", conversation_id = "", user_id = "", lang = "ja") {
        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");

        // var raw = JSON.stringify({
        //     "text": message,
        //     "bot_id": bot_id, // Use selected bot_id here
        //     "conversation_id": conversation_id, // Include conversation_id
        //     "lang":lang,
        //     "user_id": user_id
        // });

        var raw = {
            "text": message,
            "bot_id": bot_id, // Use selected bot_id here
            "conversation_id": conversation_id, // Include conversation_id
            "lang":lang,
            "user_id": user_id
        };

        // var requestOptions = {
        //     method: 'POST',
        //     headers: myHeaders,
        //     body: raw,
        //     redirect: 'follow'
        // };

        // const r = await fetch(`${config.localAuth.apiServiceUrl2}` + '/gptchat', requestOptions)
        
        // IMPORTANT! make sure the request has to be sent by the authed user
        const requestUrl='/gptchat'
        let r=await AuthRequestHelper.request("post",requestUrl,raw) 
            .then(response => response)
            // .then(result =>　console.log(result))
            .catch(error => false);
        // console.log("the returned item is ", r)
        return r;
    }
    async querySurveyBot(qIndex = 0, conversation_id = "") {
        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");

        var raw = JSON.stringify({
            "text": qIndex,
            "conversation_id": conversation_id // Include conversation_id
        });

        var requestOptions = {
            method: 'POST',
            headers: myHeaders,
            body: raw,
            redirect: 'follow'
        };

        const r = await fetch(`${config.localAuth.apiServiceUrl}${process.env.REACT_APP_SURVEY_ENDPOINT}`, requestOptions)
            .then(response => response.json())
            .then(result => result?.response)
            .catch(error => false);
        return r;
    }

    // functions to connect to the back end to edit the profiles etc 

    // Method to get bot profile by ID
    async getBotProfileById(bot_id = "") {
        // const requestOptions = {
        //     method: 'GET',
        //     headers: {
        //         "Content-Type": "application/json"
        //     },
        //     redirect: 'follow'
        // };

        // const response = await fetch(`${config.localAuth.apiServiceUrl}` + `/getBotProfileById/${bot_id}`, requestOptions)
        //     .then(response => response.json())
        //     .catch(error => {
        //         console.error('Error fetching bot profile by ID:', error);
        //         return false;
        //     })
        const requestUrl=`/getBotProfileById/${bot_id}`
        let response=await AuthRequestHelper.request("get",requestUrl, {}) 
            .then(response => response)
            .catch(error => {
                console.error('Error fetching bot profile by ID:', error);
                return false;
            })
        console.log("loaded bot profile", response.data)
        if (response && response.data.longMem) {
            
            response.data.longMem = this.parseLongMem(response.data.longMem)
        }
        return response;
    }

    // Method to get all bot profile IDs
    async getAllBotProfileIds() {
        // const requestOptions = {
        //     method: 'GET',
        //     headers: {
        //         "Content-Type": "application/json"
        //     },
        //     redirect: 'follow'
        // };

        // const response = await fetch(`${config.localAuth.apiServiceUrl}` + '/getAllBotProfileIds', requestOptions)
        //     .then(response => response.json())
        //     .catch(error => {
        //         console.error('Error fetching all bot profile IDs:', error);
        //         return false;
        //     });
        const requestUrl=`/getAllBotProfileIds`
        let response=await AuthRequestHelper.request("get",requestUrl, {}) 
            .then(response => response)
            .catch(error => {
                console.error('Error fetching all bot profile IDs:', error);
                return false;
            });
        const processedResponse = response.map((botProfile) => {
            if (botProfile.data.longMem) {
                console.log("loaded bot profile", botProfile.data)
                botProfile.data.longMem = this.parseLongMem(botProfile.data.longMem);
            }
            return botProfile;
        })
    
        return processedResponse
    }

    // Method to get bot profile by name
    async getBotProfileByName(name = "") {
        const requestOptions = {
            method: 'GET',
            headers: {
                "Content-Type": "application/json"
            },
            redirect: 'follow'
        };

        const response = await fetch(`${config.localAuth.apiServiceUrl}` + `/getBotProfileByName/${name}`, requestOptions)
            .then(response => response.json())
            .catch(error => {
                console.error('Error fetching bot profile by name:', error);
                return false;
            });
        return response;
    }

    // Method to add a new bot profile
    async addBotProfile(botProfileData) {
        // const requestOptions = {
        //     method: 'PUT',
        //     headers: {
        //         "Content-Type": "application/json"
        //     },
        //     body: JSON.stringify(botProfileData),
        //     redirect: 'follow'
        // };

        // const response = await fetch(`${config.localAuth.apiServiceUrl}` + '/addBotProfile', requestOptions)
        //     .then(response => response.json())
        //     .catch(error => {
        //         console.error('Error adding bot profile:', error);
        //         return false;
        //     });
        // always use the secured API endpoint calling
        const requestUrl=`/addBotProfile`
        let response=await AuthRequestHelper.request("put",requestUrl, botProfileData) 
            .then(response => response)
            .catch(error => {
                console.error('Error adding bot profile:', error);
                return false;
            });
        return response;
    }

    // Method to update a bot profile
    async updateBotProfile(bot_id = "", updateData = {}) {
        // const requestOptions = {
        //     method: 'PATCH',
        //     headers: {
        //         "Content-Type": "application/json"
        //     },
        //     body: JSON.stringify(updateData),
        //     redirect: 'follow'
        // };

        // const response = await fetch(`${config.localAuth.apiServiceUrl}` + `/updateBotProfile/${bot_id}`, requestOptions)
        //     .then(response => response.json())
        //     .catch(error => {
        //         console.error('Error updating bot profile:', error);
        //         return false;
        //     });
        // instead of the insecure request method, use the secure one.
        const requestUrl=`/updateBotProfile/${bot_id}`
        let response=await AuthRequestHelper.request("patch",requestUrl, updateData) 
            .then(response => response)
            .catch(error => {
                console.error('Error updating bot profile:', error);
                return false;
            });
        return response;
    }


    parseLongMem(longMemString) {

        if (typeof longMemString !== 'string' || !longMemString.trim()) return {};

        try {
            const cleanedString = longMemString
            // 1. kill every asterisk (safer than looking for '**')
            .replace(/\*/g, '')
            // 2. turn “…:␠␤” into “…: null␤” for empty values
            .replace(/:\s*$/gm, ': null');

            const yamlResult = yaml.load(cleanedString);

            if (!Array.isArray(yamlResult)) {
                console.error('YAML did not produce an array:', yamlResult);
                return {};
            }

            return yamlResult.reduce((acc, item) => {
                const [key, value] = Object.entries(item)[0];
                if (this.allowedKeys.has(key) && value !== undefined && value !== null) {
                    acc[key] = value;
                }

                return acc;
            }, {});

        } catch (err) {
            console.error('Error parsing longMem:', err);
            return {};
        }
    }
    // the old one is very buggy. So I generated a new one using ChatGPT
    // parseLongMem(longMemString) {
    //     if (!longMemString || typeof longMemString !== 'string') {
    //         console.error("Invalid longMem input:", longMemString);
    //         return {};
    //     }
    //     try {
    //         const cleanedString = longMemString.replace(/\*\*/g, '').replace(/: $/gm, ': null')

    //         const arrayFormat = yaml.load(cleanedString);
    //         const objectFormat = arrayFormat.reduce((acc, item) => {
    //             const [key, value] = Object.entries(item)[0];
    //             acc[key] = value;
    //             return acc;
    //         }, {});
    //         return objectFormat;
    //     } catch (error) {
    //         console.error("Error parsing longMem:", error.message, error.stack);
    //         return {};
    //     }
    // }

    paresYmlString(inputString) {
        // console.log('to parse string', inputString)
        let resultsArr = []
        // Step 1: Split the string by line breaks and remove empty lines
        const lines = inputString
            .trim()
            .split('\n')
            .map(line => line.trim())
            .filter(line => line.length > 0);
        // console.log("the parsed line: ",lines)
        // Match lines with bolded key (with or without colon inside) and detail
        const lineRegex = /^-\s*\*\*(.+?)\*\*\s*(?::\s*|\s+)(.+)$/;

        // Step 3: Loop through each line and extract the key and value
        lines.forEach(line => {
            const match = line.match(lineRegex);
            if (match) {
                // Extract and normalize key (remove trailing colon if present)
                let type = match[1].trim().replace(/:$/, '');
                const detail = match[2].trim();
                resultsArr.push({ type, detail });
            }
        });
        // console.log("results array", resultsArr)
        // console.log("type of results array ", typeof resultsArr)
        return resultsArr;
    }

    /* ---------- helpers for the convertJsonToYmlString function ---------------------------------------------------- */

    /** Escape a JS value so it is always a legal YAML one-liner. */
    toYamlScalar(value) {
        // console.log("to convert value", value)
        if (value === null || value === undefined || value === '') return '';            // ⇢ ''
        // if (typeof value !== 'string') return String(value);

        // numbers & booleans are always OK
        if (typeof value === 'number' || typeof value === 'boolean') return String(value);

        // plain words without punctuation are fine unquoted
        const plain = /^[\p{L}\p{N}_]+$/u; // letters / numbers / underscore
        if (plain.test(value)) return value;

        // otherwise single-quote and escape internal single quotes
        return `'${value.replace(/'/g, "''")}'`;
    }

    /** Render one “- **key**: value” line. */
    makeLine(key, value) {
        return `- **${key}**: ${this.toYamlScalar(value)}\n`;
    }

    convertJsonToYmlString(data) {
        /* array input: [{ type, detail }, … ] ------------------------------- */
        if (Array.isArray(data)) {
            return data
            .filter(it => it && typeof it === 'object')      // skip bad items
            .map(({ type, detail }) => this.makeLine(type, detail))
            .join('');
        }

        /* object input: { key: value, … } ----------------------------------- */
        if (data && typeof data === 'object') {
            return Object.entries(data)
            .map(([key, value]) => this.makeLine(key, value))
            .join('');
        }

        /* fallback ----------------------------------------------------------- */
        console.error('convertJsonToYmlString → invalid input:', data);
        return '';
    }

    // this is bad, so I regenerated using ChatGPT
    // convertJsonToYmlString(data) {
    //     if(Array.isArray(data)){
    //         // Initialize an empty string to store the YML result
    //         let ymlString = "";
        
    //         // Loop through each object in the JSON array
    //         data.forEach(item => {
    //             const { type, detail } = item; // Destructure the type and detail from each object
    //             // Append the formatted string in YML format to the result
    //             ymlString += `- **${type}:** ${detail}\n`;
    //         });
        
    //         return ymlString;
    //     }
    //     else if (typeof data === "object" && data !== null) {
    //         return Object.entries(data).map(([key, value]) => `- **${key}:** ${value}`).join("\n")
    //     } else {
    //         console.error("Invalid input: Expected an object or array but received:", data)
    //         return ""
    //     }
        
    // }

    /**
     * Convert a flat JS object to the markdown-YAML format required by
     * `parseLongMem`.
     *
     * @param {Record<string, any>} data – the long-mem object
     * @returns {string} – markdown-friendly YAML string
     */
    convertObjectToLongMemYaml(data) {
        if (!data || typeof data !== 'object' || Array.isArray(data)) {
            console.error('convertObjectToLongMemYaml » expected a plain object but got:', data);
            return '';
        }

        return Object.entries(data)
            .filter(([key]) => this.allowedKeys.has(key))           // ⬅︎ keep only allowed keys
            .map(([key, val]) => `- **${key}:** ${this.toYamlScalar(val)}`)
            .join('\n');
    }

    async loadBodMem(userId, botId)
    {
        if(!userId || !botId) return false
        // const requestOptions = {
        //     method: 'POST',
        //     headers: {
        //         "Content-Type": "application/json"
        //     },
        //     body: JSON.stringify({
        //         bot_id: botId,
        //         user_id: userId
        //     }),
        //     redirect: 'follow'
        // };
        const requestUrl=`/loadBotMem`
        let response=await AuthRequestHelper.request("post",requestUrl,{
                bot_id: botId,
                user_id: userId
            }) 
            .then(response => response)
            .catch(error => {
                console.error('Error updating bot memory:', error);
                return false;
            });
        // you should always secure the API endpoint
        // const response = await fetch(`${config.localAuth.apiServiceUrl}` + `/loadBotMem`, requestOptions)
            // .then(response => response.json())

        return response;
    }
}

export default new BotHelper();
